import { getDeviceHeaders } from './device'
import { getFingerprintJSHeaders } from './fingerprintjs'
import type { FingerprintJSHeaders } from './fingerprintjs'
import { getFingerprintJSProHeaders } from './fingerprintjs-pro'
import type { NikitaHeaders } from './nikita'
import { getNikitaHeaders } from './nikita'

export type OnboardingHeaders = FingerprintJSHeaders & NikitaHeaders

export const getOnboardingHeaders = async ({
  sidUrl,
}: {
  sidUrl: string
  session?: string
}): Promise<OnboardingHeaders> => {
  const responses = await Promise.all([
    getNikitaHeaders(sidUrl),
    getFingerprintJSHeaders(),
    getFingerprintJSProHeaders(),
    getDeviceHeaders(),
  ])

  const headers = {
    ...responses[0],
    ...responses[1],
    ...responses[2],
    ...responses[3],
  }

  return headers
}
